import React, { useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import Lottie from "react-lottie";
import SlideTabs from "../slide-tab/SlideTab";
import { useIntl } from "react-intl";
import SwipeCards from "../swipe-cards/SwipeCards";
import { BottomGallery } from "../bottom-gallery/BottomGallery";

import FirstImage from "../../assets/images/background/danut-car.jpg";
import SecondImage from "../../assets/images/background/Back1.jpeg";
import FirstPage from "../first-page/FirstPage";

import CarLogo1 from "../../assets/images/car-labels/citroen.svg";
import CarLogo2 from "../../assets/images/car-labels/ford.svg";
import CarLogo3 from "../../assets/images/car-labels/suzuki.svg";
import LottieFlag from "../../assets/images/lottie-flag.json";

import about1 from "../../assets/images/about/about1.jpeg";
import about2 from "../../assets/images/about/about2.jpeg";
import about3 from "../../assets/images/about/about3.jpeg";
import about4 from "../../assets/images/about/about4.jpeg";
import about5 from "../../assets/images/about/about5.jpeg";
import about6 from "../../assets/images/about/about6.jpeg";
import about7 from "../../assets/images/about/about7.jpeg";
import about8 from "../../assets/images/about/about8.jpeg";
import about9 from "../../assets/images/about/about9.jpeg";
import about10 from "../../assets/images/about/about10.jpeg";

import rally1 from "../../assets/images/rally/rally1.jpg";
import rally2 from "../../assets/images/rally/rally2.jpg";
import rally3 from "../../assets/images/rally/rally3.jpg";
import rally4 from "../../assets/images/rally/rally4.jpg";
import rally5 from "../../assets/images/rally/rally5.jpg";
import rally6 from "../../assets/images/rally/rally6.jpg";
import rally7 from "../../assets/images/rally/rally7.jpg";

const images = [
  about1,
  about2,
  about3,
  about4,
  about5,
  about6,
  about7,
  about8,
  about9,
  about10,
];

const images_rally = [rally1, rally2, rally3, rally4, rally5, rally6, rally7];

const Body = ({contactSectionRef}) => {
  const intl = useIntl();
  const homeSectionRef = useRef(null);
  const aboutSectionRef = useRef(null);
  const rentSectionRef = useRef(null);
  const schoolSectionRef = useRef(null);
  const driveSectionRef = useRef(null);
  const schoolDriveRef = useRef(null);


  return (
    <div className="bg-white">
      <FirstPage homeSectionRef={homeSectionRef} />

      {/* First Parallax Section with Sliding Tabs */}
      <div className="bg-white mt-8">
        <ExampleContent
          refer={aboutSectionRef}
          text={intl.formatMessage({ id: "slideTab.about.text" })}
          text2={intl.formatMessage({ id: "slideTab.about.text2" })}
        />
        <SlideTabs
          homeSectionRef={homeSectionRef}
          aboutSectionRef={aboutSectionRef}
          rentSectionRef={rentSectionRef}
          schoolSectionRef={schoolSectionRef}
          driveSectionRef={driveSectionRef}
          schoolDriveRef={schoolDriveRef}
          contactSectionRef={contactSectionRef}
          
        />
        <TextParallaxContent
          imgUrl={FirstImage}
          subheading={intl.formatMessage({ id: "slideTab.subheading1" })}
          heading={intl.formatMessage({ id: "slideTab.heading1" })}
          refer={rentSectionRef}
        >
          <ExampleContent
            text={intl.formatMessage({ id: "slideTab.about.rallyRent" })}
            rally={"rally"}
          />
        </TextParallaxContent>
      </div>
      <TextParallaxContent
        imgUrl={about3}
        subheading={intl.formatMessage({ id: "slideTab.subheading3" })}
        heading={intl.formatMessage({ id: "slideTab.heading3" })}
        refer={schoolSectionRef}
      >
        <ExampleContent
          text={intl.formatMessage({ id: "slideTab.rent.text" })}
        />
      </TextParallaxContent>
      <TextParallaxContent
        imgUrl={SecondImage}
        subheading={intl.formatMessage({ id: "slideTab.subheading2" })}
        heading={intl.formatMessage({ id: "slideTab.heading2" })}
        refer={driveSectionRef}
      >
        <ExampleContent
          text={intl.formatMessage({ id: "slideTab.drive.text" })}
        />
      </TextParallaxContent>

      <BottomGallery />
    </div>
  );
};

// ----- Parallax Content ----- //

const IMG_PADDING = 12;

const TextParallaxContent = ({
  imgUrl,
  subheading,
  heading,
  children,
  refer,
}) => {
  return (
    <div
      style={{ paddingLeft: IMG_PADDING, paddingRight: IMG_PADDING }}
      ref={refer}
    >
      <div className="relative h-[150vh]">
        <StickyImage imgUrl={imgUrl} />
        <OverlayCopy heading={heading} subheading={subheading} />
      </div>
      {children}
    </div>
  );
};

const StickyImage = ({ imgUrl }) => {
  const targetRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: targetRef,
    offset: ["end end", "end start"],
  });

  const scale = useTransform(scrollYProgress, [0, 1], [1, 0.85]);
  const opacity = useTransform(scrollYProgress, [0, 1], [1, 0]);

  return (
    <motion.div
      style={{
        backgroundImage: `url(${imgUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: `calc(100vh - ${IMG_PADDING * 2}px)`,
        top: IMG_PADDING,
        scale,
      }}
      ref={targetRef}
      className="sticky z-0 overflow-hidden rounded-3xl"
    >
      <motion.div
        className="absolute inset-0 bg-neutral-950/70"
        style={{ opacity }}
      />
    </motion.div>
  );
};

const OverlayCopy = ({ subheading, heading }) => {
  const targetRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: targetRef,
    offset: ["start end", "end start"],
  });

  const y = useTransform(scrollYProgress, [0, 1], [250, -250]);
  const opacity = useTransform(scrollYProgress, [0.25, 0.5, 0.75], [0, 1, 0]);

  return (
    <motion.div
      style={{
        y,
        opacity,
      }}
      ref={targetRef}
      className="absolute left-0 top-0 flex h-screen w-full flex-col items-center justify-center text-white"
    >
      <p className="mb-2 text-center text-xl md:mb-4 md:text-3xl">
        {subheading}
      </p>
      <p className="text-center text-4xl font-bold md:text-7xl">{heading}</p>
    </motion.div>
  );
};

const ExampleContent = ({ refer, text, text2, rally }) => {
  const intl = useIntl();
  const formattedText = intl.formatMessage({ id: "slideTab.about.text" });

  return (
    <div
      className="mx-auto max-w-7xl pb-24 pt-12 flex flex-col md:flex-row items-center gap-8"
      ref={refer ? refer : null}
    >
      {!text2 && !rally ? (
        <Lottie
          options={{
            loop: true, 
            autoplay: true, 
            animationData: LottieFlag,
            rendererSettings: {
              preserveAspectRatio: "xMidYMid slice", 
            },
          }}
          style={{ width: "50vh", height: "40vh" }}
        />
      ) : !!rally ? (
        <h2 className="flex-1 text-3xl font-bold mb-6 md:mb-0">
          <SwipeCards images={images_rally} />
        </h2>
      ) : (
        <h2 className="flex-1 text-3xl font-bold mb-6 md:mb-0">
          <SwipeCards images={images} />
        </h2>
      )}

      <div className="flex-1 flex items-center justify-center">
        <p
          className="mb-4 text-xl text-neutral-600 md:text-2xl"
          style={{
            lineHeight: 1.4,
            fontSize: "1.2rem",
            textAlign: "justify",
          }}
        >
          {text === formattedText && (
            <>
              <span className="text-red-500 font-bold text-4xl">D</span>
              <span className="font-bold">anut </span>
              <span className="text-red-500 font-bold text-4xl">B</span>
              <span className="font-bold">udai</span>
              <br />
            </>
          )}
          {text}
          {!!text2 && (
            <div style={{ marginTop: "20px" }}>
              <span className="text-red-500 font-bold text-4xl">L</span>
              <span className="font-bold">ucian </span>
              <span className="text-red-500 font-bold text-4xl">B</span>
              <span className="font-bold">udai</span>
              <br />
              {text2}
            </div>
          )}

          {!text2 && (
            <div style={{ marginTop: "10px" }}>
              <span className="font-bold">{intl.formatMessage({ id: "slideTab.about.vehicles" })}:</span> Ford Ka, Suzuki
              Swift, Ds3 R3T Max
            </div>
          )}

          {!text2 && (
            <div className="flex flex-row justify-center gap-6 mt-12">
              <div className="w-10 h-15">
                <img
                  src={CarLogo1}
                  alt="Car Logo 1"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="w-10 h-15">
                <img
                  src={CarLogo2}
                  alt="Car Logo 2"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="w-10 h-15">
                <img
                  src={CarLogo3}
                  alt="Car Logo 3"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          )}
        </p>
      </div>
    </div>
  );
};

export default Body;
